import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { WalletContainer, WalletHeader } from "../../../auth/wallet/walletStyles";
import { Box, Button, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { toggleActivateAssetModal } from "../LeaseSlice";
import PinComponent from "../../../auth/wallet/PinComponent";
import SuccessModal from "../../../components/SuccessModal";
import { /*deductPaymentFromUserWallet,*/ moveUserFunds, walletType } from "../../dashboard/DashboardUtils";
import { toast } from "react-toastify";
import {
	clearDeductWalletSuccess,
	clearMoveFundsSuccess,
	// deductFromWalletSuccess,
	moveFundsSuccess,
} from "../../../redux/WalletSlice";
import { useNavigate } from "react-router-dom";
import { updateAdminCreatedAsset } from "../utils";

const ActivateAsset = ({ activateAssetTab, setActivateAssetTab, leaseData }) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { adminWallet, /* walletDetails, */ deductWalletMessage, moveFundsMessage } = useSelector(
		(state) => state.wallet
	);
	// console.log(leaseData);

	const [loading, setLoading] = useState(false);
	const [updatedData, setUpdatedData] = useState(null);

	const mainWallet = adminWallet?.find((wallet) => wallet?.product === walletType.main);

	const fee = process.env.NODE_ENV !== "production" ? 1 : 100;

	const investorInfo = leaseData?.investorsArray?.find((investor) => investor?.user === "Fortcore Admin");

	const amount = investorInfo?.amountToInvest;

	const amountPayable = fee + Number(amount?.replaceAll(",", ""));

	const onCloseModal = () => {
		dispatch(toggleActivateAssetModal(false));
	};

	// DEDUCT ASSET FEE FROM WALLET
	// const onDeductWallet = async () => {
	// 	const details = {
	// 		walletId: walletDetails?.id,
	// 		amount: fee,
	// 		narration: "asset-activation-fee",
	// 	};
	// 	console.log(details, investorInfo);
	// 	if (mainWallet?.availableBalance < amountPayable) {
	// 		toast.error("Insuffient balance. Please fund your wallet!");
	// 		return;
	// 	}

	// 	try {
	// 		setLoading(true);
	// 		const data = await deductPaymentFromUserWallet(details, "asset-activation-fee-successful");
	// 		console.log(data);
	// 		dispatch(deductFromWalletSuccess(data));
	// 	} catch (error) {
	// 		toast.error(error);
	// 	} finally {
	// 		setLoading(false);
	// 	}
	// };

	// FUNCTION TO MOVE FUNDS TO LEASE INVESTMENT
	const moveFundsBetweenWallets = async (details) => {
		setLoading(true);
		try {
			const data = await moveUserFunds(details);
			dispatch(moveFundsSuccess(data));
			console.log(data);
		} catch (error) {
			if (error === "This session has expired. Please Login again") {
				navigate("/login");
			} else {
				toast.error(error);
			}
		} finally {
			setLoading(false);
		}
	};

	// FUNCTION TO UPDATE ASSET IN PARSE
	const onUpdateAssetInParse = async (id, data) => {
		setLoading(true);
		try {
			const res = await updateAdminCreatedAsset(id, data);
			setUpdatedData(res);
			console.log(res);
		} catch (error) {
			toast.error(error);
		} finally {
			setLoading(false);
		}
	};

	// ON PROCEED TO ACTIVE ASSETS
	const onProceedToActiveAssets = () => {
		dispatch(toggleActivateAssetModal(false));
		location.href = "/lease/active/?filter=quick_lease";
		// navigate("/lease/active/?filter=quick_lease");
	};

	useEffect(() => {
		if (deductWalletMessage === "asset-activation-fee-successful") {
			dispatch(clearDeductWalletSuccess());

			const details = {
				amount: String(amount),
				source: "main",
				destination: walletType.leaseInvestment,
				message: "investor-slot-payment-for-created-asset",
			};

			console.log(details);

			moveFundsBetweenWallets(details);
		} else {
			return;
		}
	}, [deductWalletMessage]);

	useEffect(() => {
		if (moveFundsMessage === "investor-slot-payment-for-created-asset") {
			dispatch(clearMoveFundsSuccess());

			const updatedInvestorArr = leaseData?.investorsArray.map((a) => {
				if (a.user === "Fortcore Admin") {
					return { ...a, paid: true };
				} else {
					return a;
				}
			});

			const paidSlots = leaseData?.paidSlots + investorInfo?.slots;

			const data = {
				investorsArray: updatedInvestorArr,
				paidSlots,
				status: paidSlots < 4 ? "inactive" : "active",
			};

			onUpdateAssetInParse(leaseData?.objectId, data);
		} else {
			return;
		}
	}, [moveFundsMessage]);

	useEffect(() => {
		if (updatedData) {
			setActivateAssetTab(3);
		} else {
			return;
		}
	}, [updatedData]);

	const testAdminFakePayment = () => {
		console.log(mainWallet);
		const updatedInvestorArr = leaseData?.investorsArray.map((a) => {
			if (a.user === "Fortcore Admin") {
				return { ...a, paid: true };
			} else {
				return a;
			}
		});

		const paidSlots = leaseData?.paidSlots + investorInfo?.slots;

		const data = {
			investorsArray: updatedInvestorArr,
			paidSlots,
			status: "active",
		};
		console.log(data);

		onUpdateAssetInParse(leaseData?.objectId, data);
	};

	return (
		<>
			{activateAssetTab === 1 && (
				<WalletContainer>
					<>
						<WalletHeader
							headerText='Activate Asset'
							context='Activate and list asset on market place.'
							onCloseModal={onCloseModal}
						/>
						<Typography
							marginY={2}
							color='black'>{`NGN ${amountPayable.toLocaleString()} ( N${fee} "activation fee" ) will be deducted from the admin wallet to activate and list this asset on the market place.`}</Typography>
						<Box display='grid' gridTemplateColumns='1fr 1fr' gap={2}>
							<Button variant='outlined' color='error' onClick={onCloseModal}>
								cancel
							</Button>
							<Button variant='contained' color='primary' onClick={() => setActivateAssetTab(2)}>
								proceed
							</Button>
						</Box>
					</>
				</WalletContainer>
			)}
			{activateAssetTab === 2 && (
				<PinComponent onClose={onCloseModal} onDeductFunds={testAdminFakePayment} isLoading={loading} />
			)}
			{activateAssetTab === 3 && (
				<SuccessModal
					modalText={`The amount of N${amountPayable.toLocaleString()} has been deducted and asset has been activated for leasing.`}
					btnText='proceed'
					onReqClick={onProceedToActiveAssets}
				/>
			)}
		</>
	);
};

export default ActivateAsset;

ActivateAsset.propTypes = {
	activateAssetTab: PropTypes.number,
	setActivateAssetTab: PropTypes.func,
	leaseData: PropTypes.object,
};
